import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-full pl-4 overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  class: "h-full py-5"
}
const _hoisted_3 = { class: "h-full overflow-x-hidden overflow-y-auto" }
const _hoisted_4 = { class: "flex-1 min-w-0" }

import { computed, provide, Ref } from 'vue';
import { useRoute } from 'vue-router';

import { NkStack } from '@/core/components';
import NkInspectionDevicesTree from '@/entities/inspection/components/InspectionDevicesTree.vue';
import AnnotationWorkspace from '@/teams/visionair/components/AnnotationWorkspace.vue';
import { useGetInspectionGroupQuery } from '@/entities/inspection-group/hooks';
import { useGetServiceQuery } from '@/entities/services/hooks';
import { useGetInspectionQuery } from '@/entities/inspection/hooks';
import { serviceInjectionKey } from '@/entities/services/keys';
import slugify from 'slugify';
import VoltaWorkspace from '@/teams/visionair/components/VoltaWorkspace.vue';
import InspectionVoltaDevicesTree
  from '@/entities/inspection/components/InspectionVoltaDevicesTree.vue';
import { GALLERY_MODE } from '@/entities/inspection-group/common';
import GalleryWorkspace from '@/teams/visionair/components/GalleryWorkspace.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkInspection',
  setup(__props) {

const route = useRoute();

const inspectionId = computed(() => Number(route.params.inspection));
const viewId = computed(() => Number(route.query.view));

const inspectionQueryData = computed(() => ({ id: inspectionId.value }));
const hasInspectionQueryData = computed(() => !!inspectionQueryData.value.id);
const { data: inspection } = useGetInspectionQuery(inspectionQueryData, {
  enabled: hasInspectionQueryData,
});

const inspectionGroupQueryData: Ref = computed(() => ({
  id: inspection.value?.inspectionGroup,
}));
const hasInspectionGroupQueryData = computed(() => !!inspectionGroupQueryData.value.id);
const { data: inspectionGroup } = useGetInspectionGroupQuery(inspectionGroupQueryData, {
  enabled: hasInspectionGroupQueryData,
});

// Fetching inspectionGroup Service
const serviceQueryData: Ref = computed(() => ({
  id: inspectionGroup.value?.service,
}));
const hasServiceQueryData = computed(() => !!serviceQueryData.value.id);
const { data: service } = useGetServiceQuery(serviceQueryData, {
  enabled: hasServiceQueryData,
});

const isVoltaInspection = computed(() => slugify(service.value?.name || '', { lower: true }).includes('volta'));
const isCertifiedVolta = computed(() => service.value && [9,10,12,14,16,18].includes(service.value.id));
const isVoltaExpress = computed(() => service.value?.id === 8);
const isVoltaPlus = computed(() => service.value && [13,14,15,16,17,18].includes(service.value.id))

const isGalleryInspection = computed(() => inspectionGroup.value?.mode === GALLERY_MODE);

provide(serviceInjectionKey, {
  service,
  isCertifiedVolta,
  isVoltaExpress,
  isVoltaPlus
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(viewId) !== 6)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(NkStack), {
              spacing: 3,
              class: "w-[350px]"
            }, {
              default: _withCtx(() => [
                (_unref(isVoltaInspection))
                  ? (_openBlock(), _createBlock(InspectionVoltaDevicesTree, {
                      key: 0,
                      inspection: _unref(inspectionId)
                    }, null, 8, ["inspection"]))
                  : (_openBlock(), _createBlock(NkInspectionDevicesTree, {
                      key: 1,
                      inspection: _unref(inspectionId)
                    }, null, 8, ["inspection"]))
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_unref(isVoltaInspection))
        ? (_openBlock(), _createBlock(VoltaWorkspace, {
            key: 0,
            "inspection-id": _unref(inspectionId)
          }, null, 8, ["inspection-id"]))
        : (_unref(isGalleryInspection))
          ? (_openBlock(), _createBlock(GalleryWorkspace, {
              key: 1,
              "inspection-id": _unref(inspectionId)
            }, null, 8, ["inspection-id"]))
          : (_openBlock(), _createBlock(AnnotationWorkspace, {
              key: 2,
              "inspection-id": _unref(inspectionId)
            }, null, 8, ["inspection-id"]))
    ])
  ]))
}
}

})